import type { FC } from 'react';

import { KEYMAP } from '@/domains/core/settings/constants';
import { CardText } from '@/domains/proB2BServices/Wishlists/modules/MainList/MainListCard/CardText/CardText';

import { ListCardImage } from './ListCardImage';

import styles from './ListCard.module.scss';

interface Props {
  id: number | string;
  name: string;
  productCount: number;
  onClick: () => void;
  imageUrl: string | undefined;
  tab: number;
}

export const ListCard: FC<Props> = ({
  id,
  imageUrl,
  productCount = 0,
  name,
  onClick,
  tab,
}) => (
  <div
    data-testid="ListCard"
    role="button"
    onClick={onClick}
    onKeyDown={(event: React.KeyboardEvent) => {
      const key = event.charCode || event.keyCode;
      if (key === KEYMAP.ENTER) {
        onClick();
      }
    }}
    tabIndex={tab}
    className={styles.listCard}
  >
    <ListCardImage url={imageUrl} />
    <CardText
      productCount={productCount}
      name={name}
      isBasket={id === 'aside' || id === 'main'}
    />
  </div>
);
